function buildWechatUrlScheme({
  appId,
  path,
  query,
  envVersion,
}: {
  appId: string;
  path: string;
  query?: string;
  envVersion?: string;
}) {
  if (!appId || !path) return '';

  const segments = [
    `appid=${appId}`,
    `path=${path}`,
  ];

  if (query) segments.push(`query=${encodeURIComponent(query)}`);
  if (envVersion) segments.push(`env_version=${envVersion}`);

  return `weixin://dl/business/?${segments.join('&')}`;
}

const miniProgramUsername = process.env.REACT_APP_WECHAT_MINI_PROGRAM_USERNAME?.trim() || 'gh_faac868107e9';
const miniProgramAppId = process.env.REACT_APP_WECHAT_MINI_PROGRAM_APP_ID?.trim() || 'wxe7a2f1b0a28d5acc';
const miniProgramPath = process.env.REACT_APP_WECHAT_MINI_PROGRAM_PATH?.trim() || 'pages/index/index';
const miniProgramQuery = process.env.REACT_APP_WECHAT_MINI_PROGRAM_QUERY?.trim() || '';
const miniProgramEnvVersion = process.env.REACT_APP_WECHAT_MINI_PROGRAM_ENV_VERSION?.trim() || 'release';
const miniProgramUrlScheme = process.env.REACT_APP_WECHAT_MINI_PROGRAM_URL_SCHEME?.trim() || buildWechatUrlScheme({
  appId: miniProgramAppId,
  path: miniProgramPath,
  query: miniProgramQuery,
  envVersion: miniProgramEnvVersion,
});
const wechatJsSdkSignatureUrl = process.env.REACT_APP_WECHAT_JSAPI_SIGNATURE_URL?.trim() || '';

export const miniProgramConfig = {
  username: miniProgramUsername,
  appId: miniProgramAppId,
  path: miniProgramPath,
  query: miniProgramQuery,
  envVersion: miniProgramEnvVersion,
  urlScheme: miniProgramUrlScheme,
  jsSdkSignatureUrl: wechatJsSdkSignatureUrl,
  qrFallbackHash: '#experience-qrcode',
};

export function hasWechatOpenTagConfig() {
  return Boolean(
    miniProgramConfig.username &&
    miniProgramConfig.path &&
    miniProgramConfig.jsSdkSignatureUrl
  );
}
